import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { maxBy } from 'lodash-es';
import type { DateTime } from 'luxon';
import { toDateTime } from '../../utils/date-time';

@Pipe({ name: 'maxDateTime' })
export class MaxDateTimePipe implements PipeTransform {
    transform(values: (string | DateTime)[]): any {
        const instances = values.map(value => toDateTime(value))
            .filter(value => value?.isValid);

        return maxBy(instances, instance => instance.toMillis());
    }
}
